import { AfterViewInit, Component, Inject, Input, OnChanges, OnDestroy,
         SimpleChange
       } from '@angular/core';

import { ProductConfig } from 'app/product-designer-config';
import { ProductDesignerService } from 'app/product-designer.service';
import { ConfigService } from 'core/config/config.service';
import { ProductService } from 'core/product/product.service';
import { Utils } from 'core/utils';
import { AsyncEventEmitterSubscriber } from 'core/utils/async-event-emitter';
import { CollageDesignerConfig } from './collage-designer-config';
import { DesignStepService } from './design-step/design-step.service';
import { StageService } from './stage/stage.service';

@Component({
  selector: 'collage-designer',
  templateUrl: './collage-designer.component.html',
  providers: []
})
export class CollageDesignerComponent
    implements AfterViewInit, OnChanges, OnDestroy
{
  private productHasChangedSubscription:
      AsyncEventEmitterSubscriber<ProductConfig>;
  private _isInitialized: boolean;

  public config: CollageDesignerConfig;
  @Input('designStepId') public designStepId: number;

  constructor(
      private designStepService: DesignStepService,
      @Inject(StageService) private stageService: StageService,
      @Inject(ProductService) private productService: ProductService,
      @Inject(ProductDesignerService) private productDesignerService:
          ProductDesignerService,
      @Inject(ConfigService) configService: ConfigService,
  )
  {
    this.stageService = stageService;
    this.productService = productService;
    this.config =
        this.productService.getCurrentProduct().collageDesignerConfig;
    const catalogStoreId =
        configService.getProductDesignerComponentConfig().catalogStoreId;

    this.designStepService.setStepConfigs(
        this.config.productId, catalogStoreId, this.config.steps);

    this.productHasChangedSubscription =
        this.productService.productHasChanged.subscribe(
            async (productConfig) => {
              this.config = productConfig.collageDesignerConfig;
              this.designStepService.setStepConfigs(
                  this.config.productId, catalogStoreId, this.config.steps);
              this.isInitialized = false;
              await this.designStepService.setDesignStep(0);
              this.isInitialized = true;
              await this.stageService.refreshStageConfig();
        });
  }

  public async ngOnChanges(
      changes: {[propKey: string]: SimpleChange}): Promise<void>
  {
    if (changes['designStepId']) {
      this.isInitialized = false;
      let designStepId = changes['designStepId'].currentValue;
      await this.designStepService.setDesignStep(designStepId);
      this.isInitialized = true;
      await this.stageService.refreshStageConfig();
    }
  }

  public async ngAfterViewInit(): Promise<void>
  {
    while (!this.isInitialized) {
      await Utils.sleep(10);
    }
    await this.stageService.refreshStageConfig();
  }

  public ngOnDestroy(): void
  {
    this.productService.productHasChanged.unsubscribe(
        this.productHasChangedSubscription);
  }

  public get isInitialized(): boolean
  {
    return this._isInitialized;
  }

  public set isInitialized(value: boolean)
  {
    this.productDesignerService.suspendDesignerTrigger.emit({suspend: !value});
    this._isInitialized = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/collage-designer/collage-designer.component.ts